import { isEmpty, isNull } from "@/utils/var.check";
import DOMUtils from "@utils/dom.utils";

export default {
  methods: {
    validate: function () {
      const selection = this.$rangy.getSelection();
      if (!this.hasInvalidNodes() && !this.hasNonHighlightable() && selection.rangeCount > 0) {
        let content = selection.toHtml();
        content = content.replace(/<\/?(?!img)\w*\b[^>]*>/gi, "");
        if (isEmpty(content.trim())) {
          return false;
        }
        const frag = document.createRange().createContextualFragment(content);
        let isValid = true;
        const firstNode = frag.childNodes[0] as ChildNode | undefined;
        const lastNode = frag.childNodes[frag.childNodes.length - 1] as ChildNode | undefined;
        const firstNodeHasWirisFormula =
          firstNode instanceof Element && firstNode.classList.contains("Wirisformula");
        const lastNodeHasWirisFormula =
          lastNode instanceof Element && lastNode.classList.contains("Wirisformula");
        if (
          (firstNode && firstNode.nodeType !== Node.TEXT_NODE && firstNodeHasWirisFormula) ||
          (lastNode && lastNode.nodeType !== Node.TEXT_NODE && lastNodeHasWirisFormula)
        ) {
          return false;
        }
        // For annotation in Fill in the blank question
        Array.prototype.forEach.call(frag.childNodes, function (childNode) {
          if (childNode.nodeType === Node.COMMENT_NODE) {
            isValid = false;
          }
        });
        return isValid;
      } else {
        return false;
      }
    },
    hasInvalidNodes: function () {
      const selection = this.$rangy.getSelection();
      const range = selection.getRangeAt(0);
      const nodes = range.getNodes([1], function (node) {
        return node.nodeName === "FIGURE";
      });
      return nodes.length > 0 || selection.toHtml().indexOf("input") > -1;
    },
    hasNonHighlightable: function () {
      const selection = this.$rangy.getSelection();
      const range = selection.getRangeAt(0);
      let isExist = false;
      // Find text nodes and check if highlightable
      range.getNodes().forEach((node) => {
        if (
          DOMUtils.hasClass(node, "non-highlightable") ||
          !isNull(DOMUtils.parent(node, ".non-highlightable")) ||
          isNull(DOMUtils.parent(node, ".annotatable-richtext"))
        ) {
          isExist = true;
        }
      });
      return isExist || selection.toHtml().indexOf("none-highlightable") > -1;
    },
  },
};
